module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_namie-03dce3767049214d634bda29a9bd5f92.jpg";